import { DefaultButtonsConfig } from './../../base-models/default-buttons-config';
import { ModelData } from './../../base-models/model-data';
import { InlineContainerService } from './../../base-classes/containers/services/inline-container.service';
import { BaseDataService } from './../../base-services/base-data.service';
import { BaseDetailListComponent } from './../../base-classes/base-list-component-v2';
import { BaseEntity } from './../../base-models/base-entity';
import { Component, Input } from "@angular/core";
import { TranslateService } from '@ngx-translate/core';
// import { NotificationsService } from 'angular2-notifications';
import { ModalService } from '../../base-services/modal.service';
import { NotificationService } from '../../base-services/notification-service';
// import { ToastrService } from 'ngx-toastr';
import { CryptoService } from '../../base-services/crypto.service';
@Component({
    selector: 'yt-fw-default-detail-list-inline',
    templateUrl: './default-detail-list.component.html'
})
export class DefaultDetailListInlineComponent<T extends BaseEntity> extends BaseDetailListComponent<T>{
    // constructor(
    //     protected baseDataService: BaseDataService,
    //     protected containerService: InlineContainerService<T>,
    //     protected translateService: TranslateService,
    //     protected modalService: ModalService,
    //     protected notificationsService: NotificationsService
    // ){
    //     super(baseDataService, containerService, translateService, modalService, notificationsService);
    // }

    constructor(
        protected baseDataService: BaseDataService,
        protected containerService: InlineContainerService<T>,
        protected translateService: TranslateService,
        protected modalService: ModalService,
        protected toastrService: NotificationService
    ){
        super(baseDataService, containerService, translateService, modalService, toastrService);
    }

    tableConfig: {};

    @Input() Disabled: boolean = false;

    ngOnInit(){
        super.ngOnInit();
        this.tableConfig = {
            EditIcon: {
                Visible: false
            },
            DeleteIcon: {
                Visible: true
            },
            PrintIcon: {
                Visible : false
            },
            DefaultSortKey: this._model.SortBy,
            DefaultSortReverse: this._model.SortReverse,
            ShowIndex: false,
            ShowDefaultListButtons: true,
            ShowCheckBoxes: true,
            Height: '100ww',
            DefaultListButtonsConfig: new DefaultButtonsConfig(true, true, false, false, true, true, true, true)
        }
    }

    AddItem(){
        this.containerService.AddItem();
        //this.containerService.ShowUpdate();
    }

    EditItem(item: T){
        let modelData = new ModelData(null);
        modelData.MainList = this._model;
        this.containerService.EditItem(modelData, item.ID);
        // this.containerService.EditItem(modelData, item.ID, item.Useridlk);
        //this.containerService.ShowUpdate();
    }

    SelectItem(item: T){
        this.EditItem(item);
    }

    OnItemDelete(ID: number){
        super.OnItemDelete(ID);
        this.containerService.OnItemDeleted();
    }
}
